<template>
  <div class="col-sm-12 col-md-8 mx-auto mt-4">
    <h1 class="fw-bolder text-danger">Utenza disabilitata</h1>
    <div class="col-lg-4 col-sm-7 mx-auto my-3 pb-4">
      <span class="text-primary fs-6">La tua utenza è stata disabilitata</span>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "Disabled",
  data() {
    return {};
  },
  computed: {
    ...mapState("utente", ["status", "user"]),
  },
};
</script>
<style scoped>
input {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
</style>
<style >
header.modal-header {
  border-color: transparent;
}
</style>